import React, { useEffect, useState } from "react";
import { CiCircleInfo } from "react-icons/ci";
import CustomModal from "components/modals/CustomModal";
import { failMessage } from "utils/toastMessage";
import { electricityGenerationApi } from "services/dashboard";
import { useSelector } from "react-redux";
import Placeholder from "components/placeholder/Placeholder";
import { useParams } from "react-router-dom";
import { monthsArray } from "utils/dropdownValue/selectBoxValue";
import { convertMinutesToHHMM, formatDate, formatToDecimal, formatToTimeOnly } from "utils/commonFun";
import Spinners from "loader/Spinners";

const ElectricityGeneration = () => {
  const { selectedSite } = useSelector((state) => (state?.selectedSite))
  const { year, month } = useParams()
  const [infoModal, setInfoModal] = useState(false);
  const [electricityGenerationList, setElectricityGenerationList] = useState([])
  const [electricityGenerationDetails, setElectricityGenerationDetails] = useState({})
  const [loading, setLoading] = useState(false)
  const [info, setInfo] = useState({ title: '', desc: '' })
  const filterMonth = monthsArray.find(
    (data) => data?.name?.toLowerCase() === month?.toLowerCase()
  );
  console.log('electricityGenerationList', electricityGenerationList)
  const shouldShowNoData = !loading && selectedSite?._id && electricityGenerationList?.length === 0;

  // ---------duration-Info-modal-open-------------
  const durationInfo = (title, desc) => {
    setInfo({ title: title, desc: desc })
    setInfoModal(true)
  }
  // ---------duration-Info-modal-close-------------
  const handleClose = () => {
    setInfoModal(false);
    setInfo({ title: '', desc: '' });
  }

  //--------electricity-generation-listing--------------
  useEffect(() => {
    const fetchElectricityGenerationList = async () => {
      if (selectedSite?._id) {
        try {
          setLoading(true)
          const res = await electricityGenerationApi({
            plantId: selectedSite?._id,
            year: year, //|| '2025',
            month: filterMonth?.id, //|| '5',
          })
          if (res?.status === 200) {
            const dailyStats = res?.data?.dailyStats
            const monthlyStats = res?.data?.monthlyStats
            setElectricityGenerationList(dailyStats)
            setElectricityGenerationDetails(monthlyStats)
          } else {
            failMessage(res)
          }
        } catch (e) {
          console.log('error', e?.message)
        } finally {
          setLoading(false)
        }
      }
    }
    fetchElectricityGenerationList()
  }, [selectedSite?._id, year, filterMonth])


 const getGODurationInHHMM = (array) => {
  const totalMinutes = array.reduce((acc, curr) => {
    const minutes = Number(curr?.GO_Duration || 0);
    const decimal = minutes % 1;
    const rounded = decimal > 0.30 ? Math.ceil(minutes) : Math.floor(minutes);
    return acc + rounded;
  }, 0);

  const hrs = Math.floor(totalMinutes / 60).toString().padStart(2, '0');
  const mins = (totalMinutes % 60).toString().padStart(2, '0');
  return `${hrs}:${mins}`;
};

  return (
    <>
      <div className="electricity_generation">
        <div className="container">
          <div className="_card">
            <h4>Electricity Generation</h4>
            <div className="table_wrap">
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <b>Date</b>
                    </th>
                    <th>
                      <b>Start time</b>
                    </th>
                    <th>
                      <b>Stop time</b>
                    </th>
                    <th>
                      <b>Solar Generation</b>
                    </th>
                    <th>
                      <b>GUA Duration </b>{" "}
                      <button
                        type="button"
                        onClick={() => durationInfo('GUA Duration', 'Grid Unavailability Duration is the total time the gride was not available to receive or supply power. it is calculated as: Gride Unavailability Duration = Gride Restore Time - Gride Failure Time')}>
                        <CiCircleInfo />
                      </button>
                    </th>
                    <th>
                      <b>PA Duration</b>{" "}
                      <button type="button" onClick={() => durationInfo('PA Duration', 'Plant Availability Duration is defined as the total time between a recorded Start Time and Stop Time. Plant Availability Duration = Stop Time-Start Time')}>
                        <CiCircleInfo />
                      </button>
                    </th>
                    <th>
                      <b>DC CUF</b>
                    </th>
                  </tr>
                </thead>
                {/* <tbody>
                  {loading ?
                    <div
                      style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "350px", width: "100%", }}
                    >
                      <Spinners />
                    </div> :
                    !loading && electricityGenerationList.length === 0 ?
                      <tr><td colSpan={7}>
                        <Placeholder title='No data found' />
                      </td></tr>
                      :
                      electricityGenerationList.length > 0 && electricityGenerationList.map((data, ind) => (
                        <tr key={ind}>
                          <td>{formatDate(data?.date)}</td>
                          <td>{formatToTimeOnly(data?.startTime)}</td>
                          <td>{formatToTimeOnly(data?.endTime)}</td>
                          <td>{data?.solarGeneration || "0"}</td>
                          <td>{data?.GA_Duration || "N/A"}</td>
                          <td>{data?.PA_Duration || "N/A"}</td>
                          <td>
                            {data?.dcCuf || data?.dcCuf === 0
                              ? `${Number(data.dcCuf).toLocaleString('en-IN')}%`
                              : 'N/A'}
                          </td>

                        </tr>
                      ))
                  }
                </tbody> */}
                <tbody>
                  {loading && !shouldShowNoData ? (
                    <tr>
                      <td colSpan={7} style={{ height: "350px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <Spinners />
                        </div>
                      </td>
                    </tr>
                    // ) : !loading && selectedSite?._id&& electricityGenerationList?.length === 0 ? (
                  ) : shouldShowNoData ? (
                    <tr>
                      <td colSpan={7}>
                        <Placeholder title="No data found" />
                      </td>
                    </tr>
                  ) : (
                    electricityGenerationList?.map((data, ind) => (
                      <tr key={ind}>
                        <td>{formatDate(data?.date)}</td>
                        <td>{formatToTimeOnly(data?.startTime)}</td>
                        <td>{formatToTimeOnly(data?.endTime)}</td>
                        <td>{data?.solarGeneration || "0"}</td>
                        <td>{convertMinutesToHHMM(data?.GO_Duration) || "N/A"}</td>
                        <td>{convertMinutesToHHMM(data?.PA_Duration) || "N/A"}</td>
                        <td>
                          {data?.dcCuf || data?.dcCuf === 0
                            ? `${Number(data.dcCuf).toLocaleString("en-IN")}%`
                            : "N/A"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>

              </table>
            </div>

            <div className="card_wrap">
              <div className="_card total">
                <h5>Total</h5>
                <ul>
                  <li>
                    {/* <span>Dec-24</span> */}
                    <span>GUA Duration</span>
                    <span>PA Duration</span>
                    <span>DC CUF</span>
                  </li>
                  <li>
                    {/* <span>{electricityGenerationDetails?.totalSolarGeneration || "N/A"}</span> */}
                    {/* <span>{convertMinutesToHHMM(electricityGenerationDetails?.totalGA_Minutes) || "0"}</span> */}
                    <span>{getGODurationInHHMM(electricityGenerationList) || "0"}</span>

                    <span>{convertMinutesToHHMM(electricityGenerationDetails?.totalPA_Minutes) || "0"}</span>
                    <span>
                      {electricityGenerationDetails?.avgDcCuf || electricityGenerationDetails?.avgDcCuf === 0
                        ? `${Number(electricityGenerationDetails.avgDcCuf).toLocaleString('en-IN')}%`
                        : 'N/A'}
                    </span>
                  </li>
                </ul>
              </div>
              <div className="_card deemeed_generation">
                <ul>

                  <li>
                    <span>Total Solar Generation</span>
                    {/* <b>
                      {formatToDecimal((electricityGenerationDetails?.totalSolarGeneration || 0) +
                        (electricityGenerationDetails?.totalDeemedGeneration || 0))} kWh
                    </b> */}
                    <b>{formatToDecimal(electricityGenerationDetails?.totalSolarGeneration)} kWh</b>
                  </li>
                  <li>
                    <span>
                      Total Deemed Generation{" "}
                      <button type="button" onClick={() => durationInfo('Deemeed Generation', 'Deemed Generation:Total Solar Generation / (Total PA Duration − Total GUA Duration) * Total GUA Duration')}>
                        <CiCircleInfo />
                      </button>
                    </span>
                    {/* <b>{electricityGenerationDetails?.totalDeemedGeneration || Deemed Generation= Total Generation/(Total Plant running hours- Total Downtime hours)* Total Downtime hourselectricityGenerationDetails?.totalDeemedGeneration === 0 ?
                      `${electricityGenerationDetails?.totalDeemedGeneration}kWh` : "N/A"} </b> */}
                    <b>
                      {
                        electricityGenerationDetails?.totalDeemedGeneration || electricityGenerationDetails?.totalDeemedGeneration === 0
                          ? `${formatToDecimal(electricityGenerationDetails?.totalDeemedGeneration, 2)} kWh`
                          : "0"
                      }
                    </b>

                  </li>
                  <li>
                    <span>Total Generation+ Deemed Generation</span>
                    {/* <b>
                      {formatToDecimal((electricityGenerationDetails?.totalSolarGeneration || 0) +
                        (electricityGenerationDetails?.totalDeemedGeneration || 0))} kWh
                    </b> */}
                    <b>{formatToDecimal(electricityGenerationDetails?.totalSolarGenerationWithDeemed)} kWh</b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------info-modal-------------- */}
      <CustomModal show={infoModal} handleClose={handleClose}>
        <h4>{info?.title}</h4>
        <p>{info?.desc || 'No data found'}</p>
      </CustomModal >
    </>
  );
};

export default ElectricityGeneration;
